import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { MdDownloadForOffline } from 'react-icons/md';
import { AiTwotoneDelete } from 'react-icons/ai';
import { BsFillArrowUpRightCircleFill } from 'react-icons/bs';

import { client, urlFor } from '../client';
import heartRed from '../assets/heartRed.png';
import heartWhite from '../assets/heart.png';
import LikeBlue from '../assets/likeblue.png';
import LikeWhite from '../assets/like.png';
import { useEffect } from 'react';

const Pin = ({ pin }) => {
  const [postHovered, setPostHovered] = useState(false);
  const [savingPost, setSavingPost] = useState(false);
  const [alreadySaved, setAlreadySaved] = useState(false);
  const [alreadyLiked, setAlreadyLiked] = useState(false);
  const [alreadyLoved, setAlreadyLoved] = useState(false);

  const navigate = useNavigate();

  const { postedBy, image, _id, destination } = pin;

  const user = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear();

  useEffect(() => {
    let alreadySaved = pin?.save?.filter((item) => item?.postedBy?._id === user?.googleId);
    let alreadyLiked = pin?.like?.filter((item) => item?.postedBy?._id === user?.googleId);
    let alreadyLoved = pin?.love?.filter((item) => item?.postedBy?._id === user?.googleId);
    setAlreadySaved(alreadySaved?.length > 0 ? true : false);
    setAlreadyLoved(alreadyLoved?.length > 0 ? true : false);
    setAlreadyLiked(alreadyLiked?.length > 0 ? true : false);
  }, []);

  const deletePin = (id) => {
    client
      .delete(id)
      .then(() => {
        window.location.reload();
      });
  };


  const savePin = (id) => {
    setAlreadySaved(true);

    client
      .patch(id)
      .setIfMissing({ save: [] })
      .insert('after', 'save[-1]', [{
        _key: uuidv4(),
        userId: user?.googleId,
        postedBy: {
          _type: 'postedBy',
          _ref: user?.googleId,
        },
      }])
      .commit()
      .then(() => {
        
      });
  }
  const likePin = (id) => {

    setAlreadyLiked(true);

    client
      .patch(id)
      .setIfMissing({ like: [] })
      .insert('after', 'like[-1]', [{
        _key: uuidv4(),
        userId: user?.googleId,
        postedBy: {
          _type: 'postedBy',
          _ref: user?.googleId,
        },
      }])
      .commit()
      .then(() => {
      });
  }
  const lovePin = (id) => {

    setAlreadyLoved(true);

    client
      .patch(id)
      .setIfMissing({ love: [] })
      .insert('after', 'love[-1]', [{
        _key: uuidv4(),
        userId: user?.googleId,
        postedBy: {
          _type: 'postedBy',
          _ref: user?.googleId,
        },
      }])
      .commit()
      .then(() => {
      });
  }




  return (
    <div className="m-2">
      <div
        onMouseEnter={() => setPostHovered(true)}
        onMouseLeave={() => setPostHovered(false)}
        onClick={() => navigate(`/pin-detail/${_id}`)}
        className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
      >
        <img className="rounded-lg w-full " src={(urlFor(image).width(250).url())} alt="user-post" />
        {postHovered && (
          <div
            className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
            style={{ height: '100%' }}
          >
            <div className="flex items-center justify-between">
              <div className="flex gap-2">
                <a
                  href={`${image?.asset?.url}?dl=`}
                  download
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="bg-white w-9 h-9 p-2 rounded-full flex items-center justify-center text-dark text-xl opacity-75 hover:opacity-100 hover:shadow-md outline-none"
                ><MdDownloadForOffline />
                </a>
              </div>
              {alreadySaved ? (
                <button type="button" className="bg-red-500 opacity-70 hover:opacity-100 text-white font-bold px-5 py-1 text-base rounded-3xl hover:shadow-md outline-none">
                  {pin?.save?.length}  Saved
                </button>
              ) : (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    savePin(_id);
                  }}
                  type="button"
                  className="bg-red-500 opacity-70 hover:opacity-100 text-white font-bold px-5 py-1 text-base rounded-3xl hover:shadow-md outline-none"
                >
                  {savingPost ? 'Saving' : 'Save'}
                </button>
              )}
            </div>
            <div className=" flex justify-end items-center gap-2 w-full">
              
              {
                postedBy?._id === user?.googleId && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      deletePin(_id);
                    }}
                    className="bg-white p-2 rounded-full w-8 h-8 flex items-center justify-center text-dark opacity-75 hover:opacity-100 outline-none"
                  >
                    <AiTwotoneDelete />
                  </button>
                )
              }
            </div>
          </div>
        )}
      </div>
      <div className="flex justify-around items-center mt-4 space-x-3 lg:mt-6">
        {!alreadyLiked && <div className='h-6 w-6 fill-current cursor-pointer'
          onClick={() => likePin(_id)}
        >
          <img src={LikeWhite} alt="" />
        </div>}
        {alreadyLiked && <div className='h-7 w-7 fill-current cursor-pointer'>
          <img src={LikeBlue} alt="" />
        </div>}
        {!alreadyLoved && <div className='h-6 w-6 fill-current cursor-pointer'
          onClick={() => lovePin(_id)}
        >
          <img src={heartWhite} alt="" />
        </div>}
        {alreadyLoved && <div className='h-8 w-8 fill-current cursor-pointer'>
          <img src={heartRed} alt="" />
        </div>}

      </div>
      <Link to={`/user-profile/${postedBy?._id}`} className="flex gap-2 mt-2 items-center">
        <img
          className="w-8 h-8 rounded-full object-cover"
          src={postedBy?.image}
          alt="user-profile"
        />
        <p className="font-semibold capitalize">{postedBy?.userName}</p>
      </Link>
    </div>
  )
}

export default Pin